import React, {Component} from 'react'
import Slider from 'react-slick';

import { Loader } from 'semantic-ui-react'

/**
 * @title Medias Slider
 * @dev Component responsible for displaying images or videos medias
 * ## Props :
 *  - Files : array of File type objects 
 */
class MediasSlider extends Component {
    constructor() {
        super()
        this.state = {
            loading: true,
            slideViews: undefined,
            slideSettings: undefined
        }
    }

    componentDidMount() {
        const { Files } = this.props;
        this.initSlider()
    }
   

    initSlider = async() => {
        const { Files } = this.props;

        let slideSettings = await Promise.resolve({
            adaptiveHeight:false,
            autoplay:true,
            autoplaySpeed:3500,           // default 3000
            speed : 700,                  // Slide/Fade animation speed
            centerPadding: '50px',        // default : 50
            dots : true,                  // default : false
            arrows : false,
            //appendArrows : document.querySelector('#slickarrows'),
            //appendDots : dots => <span className="ui center aligned segment" style={{display:'flex', justifyContent:"center"}}>{dots}</span>,
            dotsClass : 'slick-dats',
            respondTo: 'min',
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1
        })

        var slideViews = await new Promise((resolve) => {
            var fileElement = (f) => {
                return new Promise(async(fE) => {
                    let Key = await Promise.resolve(Math.floor(Math.random() * 1000000))
                    fE(
                        f.mimetype.indexOf('image') >= 0 
                        ? <div key={Key}><img className="ui centered huge image gallery-item" alt="" src={f.location} /></div>
                        : <div key={Key}><video className="gallery-item" height="100%" controls src={f.location} alt=""></video></div>
                    )
                })
            }
            let views = []

            Files && Files.length && Files.map(async(_f, fi) => {
                let $e = await fileElement(_f)
                views.push($e)

                if (fi === Files.length-1)
                    resolve(views)
            })

        })

        this.setState({slideViews:slideViews, slideSettings:slideSettings, loading:false})
        
    }

    maybeShowLoader = () => {
        const { loading } = this.state

        return(
            loading
            ? <Loader />
            : ''
        )
    }

    maybeShowSlider = () => {
        const { loading , slideSettings, slideViews} = this.state

      
        if (!loading && slideSettings && slideViews)
            return(
                <div><Slider {...slideSettings}>
                    {slideViews}
                </Slider></div>
            )    
        
    }

    render() {
        
        return(
            <div>
                
                {this.maybeShowLoader()}
                {this.maybeShowSlider()}
            
            </div>
        )
    }

}

export default MediasSlider